import messages from '../components/message/messages';
import { showMessage } from './show-message';

export const showMessageByType = (type) => {
  const message = messages[type];
  return showMessage(message.content(), message.type, message.messageKey, message.linkMessageKey, message.variables);
};
